'use strict';

var $ = require('jquery');

var modules = [{
    name: 'cookie-banner',
    module: require('./modules/cookie-banner')
}, {
    name: 'main-navigation',
    module: require('./modules/main-navigation')
}, {
    name: 'footer-navigation',
    module: require('./modules/footer-navigation')
}, {
    name: 'navigation',
    module: require('./modules/navigation')
}, {
    name: 'change-location',
    module: require('./modules/change-location')
}, {
    name: 'membership-journey',
    module: require('./modules/membership-journey')
}, {
    name: 'membership-form-toggle',
    module: require('./modules/membership-form-toggle')
}, {
    name: 'compare-membership',
    module: require('./modules/compare-membership')
}, {
    name: 'interactive-mosaic',
    module: require('./modules/interactive-mosaic')
}, {
    //     name: 'equal-height',
    //     module: require('./utilities/equal-height')
    // }, {
    name: 'breadcrumb-toggle',
    module: require('./modules/breadcrumb-toggle')
}, {
    //     name: 'sticky-navigation',
    //     module: require('./modules/sticky-navigation')
    // }, {
    name: 'module-toggle',
    module: require('./modules/module-toggle')
}, {
    name: 'content-slideshow',
    module: require('./modules/content-slideshow')
}, {
    name: 'standard-content-reveal',
    module: require('./modules/standard-content-reveal')
}, {
    name: 'video-play',
    module: require('./modules/video-play')
}, {
    name: 'hotspot',
    module: require('./modules/in-text-hotspot')
}, {
    name: 'content-highlight',
    module: require('./modules/content-highlight')
}, {
    name: 'content-tabs',
    module: require('./modules/content-tabs')
}, {
    name: 'form-address',
    module: require('./modules/form-address')
}, {
    //     name: 'appeal-progress',
    //     module: require('./modules/appeal-progress')
    // }, {
    name: 'ask-document-block',
    module: require('./modules/ask-document-block')
}, {
    name: 'tools-block',
    module: require('./modules/tools-block')
}, {
    name: 'activity-map',
    module: require('./modules/activities/activity-map')
}, {
    name: 'activity-tabs',
    module: require('./modules/activities/activity-tabs')
}, {
    name: 'activities-load',
    module: require('./modules/activities/activities-load')
}, {
    name: 'activities-map-filters',
    module: require('./modules/activities/activities-map-filters')
}, {
    name: 'activity-filter',
    module: require('./modules/activities/activity-filter')
}, {
    name: 'activity-completion',
    module: require('./modules/activities/activity-completion')
}, {
    name: 'activity',
    module: require('./modules/activities/activity')
}, {
    name: 'activities-sort-options',
    module: require('./modules/activities/activities-sort-options')
}, {
    name: 'activity-detail-print',
    module: require('./modules/activities/activity-detail-print')
}, {
    name: 'register-tracking',
    module: require('./modules/register-form-tracking')
}, {
    name: 'register',
    module: require('./modules/register-form')
}, {
    name: 'campaign-progress-bar',
    module: require('./modules/campaign-progress-bar')
}, {
    name: 'map-signpost',
    module: require('./modules/map-signpost')
}, {
    name: 'can-have-anchor',
    module: require('./modules/anchor-smooth-scroll')
}, {
    name: 'form-toggle',
    module: require('./modules/form-toggle')
}, {
    name: 'personal-results',
    module: require('./modules/bgbw/personal-results')
}, {
    name: 'bgbw-submit-membership-form',
    module: require('./modules/bgbw/bgbw-submit-membership-form')
}, {
    name: 'bird-select',
    module: require('./modules/bgbw/bird-select')
}, {
    name: 'bird-frequency',
    module: require('./modules/bgbw/bird-frequency')
}, {
    name: 'nationwide-results',
    module: require('./modules/bgbw/nationwide-results')
}, {
    name: 'countdown',
    module: require('./modules/countdown')
}, {
    name: 'input-number',
    module: require('./modules/input-number')
}, {
    name: 'message-toggle',
    module: require('./modules/message-toggle')
}, {
    name: 'contact-lookup',
    module: require('./modules/contact-lookup')
}, {
    name: 'session-keep-alive',
    module: require('./utilities/session-keep-alive')
}, {
    name: 'school-form',
    module: require('./modules/school-form')
}, {
    name: 'hot-stats-counter',
    module: require('./modules/hot-stats-counter')
}, {
    name: 'custom-questions',
    module: require('./modules/custom-questions')
}, {
    name: 'radio-list',
    module: require('./modules/radio-list')
}, {
    name: 'charting-modal',
    module: require('./modules/charting/charting-modal')
}, {
    name: 'charting-selector',
    module: require('./modules/charting/charting-selector')
}, {
    name: 'charting-type-reveal',
    module: require('./modules/charting/charting-type-reveal')
}, {
    name: 'charting-data-set-reveal',
    module: require('./modules/charting/charting-data-set-reveal')
}, {
    name: 'charting-print-chart',
    module: require('./modules/charting/charting-print-chart')
}, {
    name: 'map-block',
    module: require('./modules/map-block')
}, {
    name: 'map-list-tabs',
    module: require('./modules/map-list-tabs')
}, {
    name: 'form-multiple-address',
    module: require('./modules/form-multiple-address')
}, {
    name: 'reveal-and-hide-text-block',
    module: require('./modules/reveal-and-hide-text-block')
}, {
    //     name: 'ajax-tabs',
    //     module: require('./modules/ajax-tabs')
    // }, {
    name: 'profile-edit',
    module: require('./modules/profile/profile-edit')
}, {
    name: 'personal-plan-postcode-hero',
    module: require('./modules/personal-plan/personal-plan-postcode-hero')
}, {
    name: 'personal-plan-activity-completion',
    module: require('./modules/personal-plan/personal-plan-activity-completion')
}, {
    name: 'personal-plan-activities-load',
    module: require('./modules/personal-plan/personal-plan-activities-load')
}, {
    name: 'personal-plan-create',
    module: require('./modules/personal-plan/personal-plan-create')
}, {
    name: 'wild-challenge-close-hero',
    module: require('./modules/wild-challenge/wild-challenge-close-hero')
}, {
    name: 'wild-challenge-signup-form',
    module: require('./modules/wild-challenge/wild-challenge-signup-form')
}, {
    name: 'file-upload',
    module: require('./modules/file-upload')
}, {
    name: 'disable-field',
    module: require('./modules/disable-field')
}, {
    name: 'wild-challenge-show-activities',
    module: require('./modules/wild-challenge/wild-challenge-show-activities')
}, {
    name: 'unsaved-form-prompt',
    module: require('./modules/unsaved-form-prompt')
}, {
    name: 'duplicate-form-field',
    module: require('./modules/duplicate-form-field')
}, {
    name: 'social-reward-modal',
    module: require('./modules/rewarding/social-reward-modal')
}, {
    name: 'membership-options',
    module: require('./modules/membership-options')
}, {
    name: 'simple-tabs',
    module: require('./modules/simple-tabs')
}, {
    name: 'gallery',
    module: require('./modules/gallery')
}, {
    name: 'audio-player',
    module: require('./modules/audio-player')
}, {
    name: 'species-calendar',
    module: require('./modules/species-calendar')
}, {
    name: 'character-count',
    module: require('./modules/character-count')
}, {
    name: 'mobile-text-toggle',
    module: require('./modules/mobile-text-toggle')
}, {
    name: 'membership-renewal-total',
    module: require('./modules/membership-renewal-total')
}, {
    name: 'membership-lookup',
    module: require('./modules/membership-lookup')
}, {
    name: 'expiry-date',
    module: require('./modules/forms/expiry-date')
}, {
    name: 'guide-filter',
    module: require('./modules/guide-filter')
}, {
    name: 'donation-tabs',
    module: require('./modules/donation-tabs')
}, {
    name: 'donation-amount-confirmation',
    module: require('./modules/donation-amount-confirmation')
}, {
    name: 'payment-toggle',
    module: require('./modules/payment-toggle')
}, {
    name: 'password-toggle',
    module: require('./modules/password-toggle')
}, {
    name: 'card-type',
    module: require('./modules/card-type')
}, {
    name: 'change-payment',
    module: require('./modules/change-payment')
}, {
    name: 'account-login',
    module: require('./modules/forms/account-login')
}, {
    name: 'donation-tabs-querystring',
    module: require('./modules/donation-tabs-querystring')
}, {
    name: 'feed-filter',
    module: require('./modules/feed-filter')
    /*, {
        name: 'image-stick-parallax',
        module: require('./modules/image-stick-parallax')
    }*/
}, {
    name: 'disable-submit',
    module: require('./modules/disable-submit')
}, {
    name: 'language-select',
    module: require('./modules/language-select')
}, {
    name: 'contact-email',
    module: require('./modules/forms/contact-email')
}, {
    name: 'apple-pay',
    module: require('./modules/apple-pay')
}, {
    name: 'wild-challenge-proof-module',
    module: require('./modules/wild-challenge/wild-challenge-proof-module')
}, {
    //     name: 'filter-block',
    //     module: require('./modules/filter-block')
    // }, {
    name: 'lottery',
    module: require('./modules/lottery')
}, {
    name: 'reveal-content',
    module: require('./modules/reveal-content')
}, {
    name: 'membership-renewal-overseas-postcode',
    module: require('./modules/membership-renewal-overseas-postcode')
}, {
    name: 'form-scroll-to-error',
    module: require('./modules/form-scroll-to-error')
}, {
    name: 'pick-of-the-week',
    module: require('./modules/pick-of-the-week')
}, {
    name: 'contact-show-dob',
    module: require('./modules/contact-show-dob')
}, {
    name: 'responsive-table',
    module: require('./modules/responsive-table')
}, {
    name: 'contact-us',
    module: require('./modules/contact-us')
}, {
    name: 'show-password',
    module: require('./modules/show-password')
}, {
    name: 'appeals-list',
    module: require('./modules/appeals-list')
}, {
    name: 'auto-countdown',
    module: require('./modules/auto-countdown')
}, {
    name: 'bird-identifier',
    module: require('./modules/bird-identifier')
}, {
    name: 'report-email-multiple',
    module: require('./modules/report-email-multiple')
}, {
    name: 'report-recaptcha',
    module: require('./modules/report-recaptcha')
}, {
    name: 'species-variations',
    module: require('./modules/species-variations')
}, {
    name: 'navigation-map-listing',
    module: require('./modules/navigation-map-listing')
}, {
    name: 'satellite-map-list-tabs',
    module: require('./modules/satellite-map-list-tabs')
}, {
    name: 'species-gallery',
    module: require('./modules/species-gallery')
}, {
    //     name: 'sticky-navigation-alternative',
    //     module: require('./modules/sticky-navigation-alternative')
    // }, {
    name: 'gdpr-preferences',
    module: require('./modules/gdpr-preferences')
}, {
    name: 'supporter-details-page',
    module: require('./modules/supporter-details-page')
}, {
    name: 'reserve-plan-your-visit',
    module: require('./modules/reserve-plan-your-visit')
}, {
    name: 'reserve-tabs',
    module: require('./modules/reserve-tabs')
}, {
    name: 'reserve-seasonal-highlights',
    module: require('./modules/reserve-seasonal-highlights')
}, {
    name: 'video-container',
    module: require('./modules/video-container')
}, {
    name: 'hero-carousel',
    module: require('./modules/hero-carousel')
}, {
    name: 'under-age',
    module: require('./modules/under-age')
}, {
    name: 'news-blog-social',
    module: require('./modules/news-blog-social')
}, {
    name: 'gtm-data',
    module: require('./modules/gtm-data')
}, {
    name: 'podcast',
    module: require('./modules/podcast')
}, {
    name: 'autocomplete',
    module: require('./modules/autocomplete')
}, {
    name: 'bird-select-autocomplete',
    module: require('./modules/bgbw/bird-select-autocomplete')
}, {
    name: 'trim-whitespace',
    module: require('./modules/trim-whitespace')
}, {
    name: 'contact-block',
    module: require('./modules/contact-block')
}, {
    name: 'prevent-multiple-submission',
    module: require('./modules/prevent-multiple-submission')
}, {
    name: 'check-password',
    module: require('./modules/check-password')
}, {
    name: 'login-page',
    module: require('./modules/login-page')
}, {
    name: 'pattern-library',
    module: require('./modules/pattern-library')
}];

function initModules() {

    for (var i = 0; i < modules.length; i++) {
        var Module = modules[i].module;

        var moduleName = $('[data-behavior~="' + modules[i].name + '"]');
        if (moduleName.length > 0) {
            var context = moduleName;
            var module = new Module({
                context: context
            });
            module.init();
        }
    }
}

function initTransitions() {
    $('body').removeClass('preload');
}

initModules();
initTransitions();

/**
 * Content tabs with controls position underneath the tab content
 */
var ContentTabsMod = require('./modules/content-tabs');
var $contentTabsBottom = $('[data-behavior="content-tabs-bottom"]');
if ($contentTabsBottom.length > 0) {
    var context = $contentTabsBottom;
    var contentTabsModInst = new ContentTabsMod({
        context: context,
        tabControlPos: 'bottom'
    });
    contentTabsModInst.init();
}


//////////////////
// WEBPACK FOOTER
// ./src/scripts/app.js
// module id = 176
// module chunks = 0